import React from 'react'
import MainNavbar from '../Navbar'
import Footer from '../Footer'


export default function index(props) {
    return (
      <div style={{backgroundColor: '#efefef'}}>
        <MainNavbar />
        {props.children}
        <Footer></Footer>  
      </div>
    )
}
